// extracted by mini-css-extract-plugin
export default {"container":"Notefound_container__u1Wz-","number":"Notefound_number__eRVhP"};